import { useState } from 'react';
import { useDepartmentScope } from '@/modules/shared/hr-lookups';
import { EMPTY_REQUEST_FILTERS, RequestFilters } from './service-desk.types';

/**
 * State for a requests list's filters, plus the `DepartmentId` clause to send with them.
 * `departmentCondition` follows the user's department permissions (see `useDepartmentScope`), so
 * the list only ever holds the departments this reviewer may see; `departments` are those, for the
 * Department column and its filter (see `departmentColumn`).
 */
export const useRequestFilters = () => {
  const [filters, setFilters] = useState<RequestFilters>(EMPTY_REQUEST_FILTERS);
  const { departments, getDepartmentIdCondition, isLoading } = useDepartmentScope();
  return {
    filters,
    setFilters,
    departments,
    departmentCondition: getDepartmentIdCondition(filters.departmentId),
    /** A department-limited reviewer's list is only right once their departments are known. */
    isScopeLoading: isLoading,
  };
};
